import React from "react";
import "../../Styles/certified/infiniti.css";

export default function Finzly() {
  return (
    <>
      <div className="infiniti-certified-details-section">
        <div className="infiniti-certified-details-title">
          OUTSTANDING WORKPLACES CERTIFIED COMPANIES
        </div>
        <div className="infiniti-certified-details-container">
          {/* Left: Badge and Company Info side by side */}
          <div className="infiniti-certified-details-left">
            <img
              src="/june_2026.png"
              alt="Outstanding Workplaces Certified"
              className="infiniti-certified-badge"
            />
            <div className="infiniti-certified-company-names">
              <a href="https://www.infinitisoftware.net/" target="_blank" rel="noopener noreferrer">
              <img
                src="/assets/infiniti/infiniti_logo.png"
                alt="Walkzero Logo"
                className="infiniti-certified-company-logo"
              />
            </a>
              <h1 className="infiniti-certified-full-name">
              Infiniti Software Solutions Pvt Ltd
              </h1>
            </div>
          </div>
          {/* Right: Company Image */}
          <div className="infiniti-certified-details-right">
            <img
              src="/assets/infiniti/infiniti_3.jpg"
              alt="Finzly Office"
              className="infiniti-certified-company-image"
            />
          </div>
        </div>
        {/* Description section below */}
        <div className="infiniti-certified-description">
          <h2>
            Why Infiniti Software Solutions Pvt Ltd is an Outstanding Workplaces
          </h2>
          <p>
            Infiniti Software Solutions is a leading travel technology company headquartered in Chennai, India. Since 2005, we have been building innovative software solutions that power airlines, travel agencies, corporate travel management companies, and travel businesses across the globe.

          </p>
          <p>
            Our mission is to simplify and enhance the travel experience through technology. We develop world-class travel and aviation solutions that help organizations streamline operations, improve customer experiences, and drive business growth.
          </p>
          <p>
            At Infiniti, innovation, learning, ownership, and people-centricity are at the core of our culture. We foster an environment where employees are empowered to innovate boldly, grow continuously, belong fully, and create global impact.
          </p>
          <p>
            Infiniti is committed to creating a workplace where employees feel valued, supported, and inspired to grow. We invest in continuous learning, employee well-being, leadership development, diversity & inclusion, and meaningful career opportunities.
          </p>
          <p>
            Beyond business, Infiniti actively contributes to society through impactful CSR initiatives focused on education, women empowerment, accessibility, sports inclusion, community development, and digital transformation for social organizations.
          </p>
        </div>
        {/* Info Cards Section */}
        <div className="infiniti-certified-info-cards">
          <div className="infiniti-certified-info-card">
            <div className="infiniti-certified-info-title">COMPANY SIZE</div>
            <div className="infiniti-certified-info-value">340 Employees</div>
          </div>
          <div className="infiniti-certified-info-card">
            <div className="infiniti-certified-info-title">INDUSTRY</div>
            <div className="infiniti-certified-info-value">Travel Technology | Airline Technology | SaaS Software Products

</div>
          </div>
          <div className="infiniti-certified-info-card">
            <div className="infiniti-certified-info-title">CONNECT</div>
            <div className="infiniti-certified-info-icons">
              <span className="infiniti-certified-icon-round">
                <a href="https://www.infinitisoftware.net/" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/website.png" alt="Website" />
                </a>
              </span>
              <span className="infiniti-certified-icon-round">
                <a href="https://www.linkedin.com/company/infinitisoftware/" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/linkedin.png" alt="LinkedIn" />
                </a>
              </span>
              <span className="infiniti-certified-icon-round">
                <a href="https://www.facebook.com/infinitisoftwaresolutionsprivatelimited/" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/facebook.png" alt="Facebook" />
                </a>
              </span>
            </div>
          </div>
          <div className="infiniti-certified-info-card">
            <div className="infiniti-certified-info-title">LOCATION (HQ)</div>
            <div className="infiniti-certified-info-value">Chennai</div>
          </div>
        </div>
        {/* Recognitions Section */}
        <div className="infiniti-certified-recognition-section">
          <h2 className="infiniti-certified-recognition-title">
            Recognitions awarded by Outstanding Workplaces
          </h2>
          <div className="infiniti-certified-recognition-badge">
            <img
              src="/june_2026.png"
              alt="Outstanding Workplaces Certified"
              className="infiniti-certified-recognition-image"
            />
          </div>
          <div className="infiniti-certified-recognition-label">
            Outstanding Workplaces - Certified
          </div>
        </div>
        {/* Life at Finzly Section */}
        <div className="infiniti-certified-life-section">
          <h2 className="infiniti-certified-life-title">
            Life at Infiniti Software Solutions Pvt Ltd 
          </h2>
          <div className="infiniti-certified-life-gallery">
            <div className="infiniti-certified-life-col">
              <img src="/assets/infiniti/infiniti_2.jpg" alt="Office 1" className="infiniti-certified-life-img" />
              <img src="/assets/infiniti/infiniti_3.jpg" alt="Team 1" className="infiniti-certified-life-img" />
            </div>
            <div className="infiniti-certified-life-col infiniti-certified-life-center">
              <img src="/assets/infiniti/infiniti_4.jpg" alt="Main Office" className="infiniti-certified-life-img infiniti-certified-life-img-large" />
            </div>
            <div className="infiniti-certified-life-col">
              <img src="/assets/infiniti/infiniti_5.jpg" alt="Office 2" className="infiniti-certified-life-img" />
              <img src="/assets/infiniti/infiniti_6.png" alt="Team 2" className="infiniti-certified-life-img" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
